export default {
  label: "CMS Dashboard",
  initials: "CMS",
};
